import { render, staticRenderFns } from "./PaymentElement.vue?vue&type=template&id=1b6db1e8&scoped=true&"
import script from "./PaymentElement.vue?vue&type=script&lang=js&"
export * from "./PaymentElement.vue?vue&type=script&lang=js&"
import style0 from "./PaymentElement.vue?vue&type=style&index=0&id=1b6db1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6db1e8",
  null
  
)

export default component.exports